<template>
    <div>
        <div class="page-title">支付申请</div>
        
        <div class="zt-types">
            
            <template v-for="(item,ik) in ecManager.organizationTypes">
                <div class="zt-type" @click="saveChange(item.value)" :key="ik"
                     :class="{ 'active' :type === item.value }">
                    <div class="line-1"><img class="icon" :src="item.icon" alt=""></div>
                    <div class="line-2">{{ item.label }}</div>
                    <div class="line-3"></div>
                    <div class="line-4">{{ item.summary }}</div>
                </div>
            </template>
        
        </div>
    
    </div>
</template>

<script>
import ecApply from "@/store/ec-apply";

export default {
    name: "Index",
    components: {},
    props: {
        apply: Object
    },
    data() {
        return {
            type: '',
            showModal: false,
            ecManager: ecApply,
        }
    },
    methods: {
        saveChange(type) {
            ecApply.initApply(type)
        },
        params() {
            return {
                organization_type: this.type,
            }
        }
    }
}
</script>

<style lang="less" scoped>

.zt-types {
    display: flex;
    justify-content: left;
}

.zt-type {
    cursor: pointer;
    width: 240px;
    height: 224px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    padding: 24px;
    margin-right: 48px;
    
    &:active, &.active {
        border: 1px solid #333333;
    }
    
    .line-1 {
        margin-bottom: 24px;
    }
    
    .line-3 {
        height: 1px;
        border: 1px solid #EEEEEE;
        margin-bottom: 16px;
    }
    
    .line-2 {
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
    }
    
    .line-4 {
        width: 192px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
    }
    
    .icon {
        width: 24px;
    }
}

.zt-ts {
    margin: 0 auto;
    width: 322px;
    height: 44px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    text-align: center;
}

</style>